import React, { useState, useEffect } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { Row, Col } from "react-bootstrap";
import notify from "../../ReusableComponents/ToastifyAlerts";

const AddEditHierarchyValues = (props) => {
  const [inputValues, setInputValues] = useState({});
  const [Stor, SetStore] = useState([]);
  const [stateValues, setStateValues] = useState([]);
  const [districtValues, setDistrictValues] = useState([]);
  const [regionValues, setRegionValues] = useState([]);

  // Build hierarchy chain
  const GetList = () => {
    const chain = [];
    let current = props.AllData?.find(
      (item) => item.hierarchyId === parseInt(props.SelectHi?.hierarchyId)
    );
    while (current) {
      chain.unshift(current);
      if (current.parentHierarchyId === 0) break;
      current = props.AllData?.find(
        (item) => item.hierarchyId === current.parentHierarchyId
      );
    }
    return chain;
  };

  useEffect(() => {
    SetStore(GetList());
  }, [props.SelectHi]);

  const GetRegions = async () => {
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetStatebyInstitute?InstituteId=${props.InstId}&HierarchyId=${props.AllData.find(item => item.hierarchy === "Region")?.hierarchyId}`
      );
      setRegionValues(res.data);
    } catch (err) {
      console.log("Error fetching regions:", err);
    }
  };

  const GetStates = async (e) => {
    try {
      const res = await axiosInstance.get(
        props.SelectHi.headerValue.includes("District") ?
          `/NCLAdmin/GetStatebyInstitute?InstituteId=${props.InstId}&HierarchyId=${props.AllData.find(item => item.hierarchy === "State")?.hierarchyId}`
          : `/NCLAdmin/GetInstituteStateDistrict?ParentId=0`
      );
      setStateValues(res.data);
    } catch (err) {
      console.log("Error fetching states:", err);
    }
  };
  useEffect(() => {
    GetRegions();
    if (props.SelectHi.instituteId === 1 || props.SelectHi.instituteId === 3 || props.SelectHi.instituteId === 6) {
      // GetRegionStates();
    } else {
      GetStates();
    }
  }, []);
  const GetRegionStates = async (PId, Type) => {
    try {
      const res = await axiosInstance.get(`/NCLAdmin/GetStateDistrictbyInstitute?InstituteId=${props.SelectHi.instituteId}&ParentId=${PId}`);
      if (Type === "State") {
        setStateValues(res.data);
      } else if (Type === "District") {
        setDistrictValues(res.data);
      }
    }
    catch (err) { console.log(err) }
  }
  // Handle input change (State triggers District fetch)
  const handleInputChange = async (hierarchyId, value) => {
    setInputValues((prev) => ({
      ...prev,
      [hierarchyId]: value,
    }));

    const selectedHierarchy = Stor.find(
      (item) => item.hierarchyId === hierarchyId
    );
    const SMasterId = stateValues.find((item) => item.id === parseInt(value))
    // && (props.SelectHi.instituteId !== 1 || props.SelectHi.instituteId !== 3 || props.SelectHi.instituteId !== 6)
    if (selectedHierarchy?.hierarchy === "State") {
      try {
        const res = await axiosInstance.get(
          `/NCLAdmin/GetInstituteStateDistrict?ParentId=${SMasterId?.masterStateId}`
        );
        setDistrictValues(res.data);
      } catch (err) {
        console.log("Error fetching districts:", err);
      }
    }
  };

  const getParentId = () => {
    const region = Stor.find(item => item.hierarchy === "Region");
    return inputValues[region?.hierarchyId] || 0;
  };

  const postHierarchyValues = async () => {
    try {
      const selectedHierarchy = Stor.find(
      item => item.hierarchyId === props.SelectHi.hierarchyId
);
      const hierarchy = selectedHierarchy?.hierarchy;

      const selectedInput = inputValues[props.SelectHi.hierarchyId] ?? "";

      let value = "";
      let parentId = 0;

      if (hierarchy === "Region") {
        value = selectedInput;
      }

      if (hierarchy === "State") {
        const stateId = parseInt(selectedInput);
        const selectedState = stateValues.find(s => s.id === stateId);
        value = selectedState?.stateDistrictName || "";

        const region = Stor.find(i => i.hierarchy === "Region");
        parentId = inputValues[region?.hierarchyId] || 0;
      }

      if (hierarchy === "District") {
        const districtId = parseInt(selectedInput);
        const selectedDistrict = districtValues.find(d => d.id === districtId);
        value = selectedDistrict?.stateDistrictName || "";

        const state = Stor.find(i => i.hierarchy === "State");
        parentId = inputValues[state?.hierarchyId] || 0;
      }
      const payload = {
        instituteId: props.SelectHi?.instituteId,
        hierarchyId: props.SelectHi.hierarchyId,
        value:value,
        parentId
      };
      const res = await axiosInstance.post(`/NCLAdmin/SaveInstituteHierarchyValues`, payload);
      props.Clear(false);
      props.GetIHVList(props.SelectHi?.hierarchyId);
      notify("Value added successfully", "success");
    } catch (err) {
      notify("Error adding value", "error");
    }
  };

  return (
    <div
      className="Card AddStudent-maindiv"
      style={Stor.length === 1 ? { width: "400px", margin: "0 auto" } : {}}
    >
      <div className="dflex alignitems JSBetween">
        <div className="AddStudent-Title Helvetica">Add Value</div>
        <IoMdCloseCircleOutline onClick={() => props.Clear(false)} />
      </div>

      <div className="container-fluid">
        {Stor.find(item => item.hierarchy === "Region") ? (
          <>
            <Row className="mb-3">
              {Stor.find(item => item.hierarchy === "Region") && (
                Stor.length > 1 ? (
                  <Col md={6}>
                    <div className="DropdownHeader">Region<span>*</span></div>
                    <select
                      className="NCLDropdown w-100"
                      value={inputValues[Stor.find(item => item.hierarchy === "Region")?.hierarchyId] || ""}
                      onChange={(e) => {
                        const region = Stor.find(item => item.hierarchy === "Region");
                        handleInputChange(region?.hierarchyId, e.target.value);
                        // GetStates(e.target.value);
                        if (Stor.find(item => item.hierarchy === "District")) {
                          GetRegionStates(e.target.value, "State");
                        } else {
                          GetStates();
                        }
                      }}
                    >
                      <option value="">Select Region</option>
                      {regionValues.map((region) => (
                        <option key={region.id} value={region.id}>
                          {region.stateDistrictName}
                        </option>
                      ))}
                    </select>
                  </Col>
                ) : (
                  <Col md={12}>
                    <div className="DropdownHeader">Region<span>*</span></div>
                    <input
                      type="text"
                      name="Region"
                      className="NCLDropdown w-100"
                      placeholder="Enter Value"
                      value={inputValues[Stor.find(item => item.hierarchy === "Region")?.hierarchyId] || ""}
                      onChange={(e) => {
                        const region = Stor.find(item => item.hierarchy === "Region");
                        handleInputChange(region?.hierarchyId, e.target.value);
                      }}
                    />
                  </Col>
                )
              )}
              {Stor.find(item => item.hierarchy === "State") && (
                <Col md={Stor.length === 1 && Stor[0].hierarchy === "State" ? 12 : 6}>
                  <div className="DropdownHeader">State<span>*</span></div>
                  <select
                    className="NCLDropdown w-100"
                    value={inputValues[Stor.find(item => item.hierarchy === "State")?.hierarchyId] || ""}
                    onChange={(e) => {
                      const state = Stor.find(item => item.hierarchy === "State");
                      handleInputChange(state?.hierarchyId, e.target.value);
                      // GetRegionStates(e.target.value, "District");
                    }}
                  >
                    <option value="">Select State</option>
                    {stateValues.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.stateDistrictName}
                      </option>
                    ))}
                  </select>
                </Col>
              )}
            </Row>

            <Row>
              {Stor.find(item => item.hierarchy === "District") && (
                <Col md={12}>
                  <div className="DropdownHeader">District<span>*</span></div>
                  <select
                    className="NCLDropdown w-50"
                    value={inputValues[Stor.find(item => item.hierarchy === "District")?.hierarchyId] || ""}
                    onChange={(e) => {
                      const district = Stor.find(item => item.hierarchy === "District");
                      handleInputChange(district?.hierarchyId, e.target.value);
                    }}
                    disabled={!districtValues.length}
                  >
                    <option value="">Select District</option>
                    {districtValues.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.stateDistrictName}
                      </option>
                    ))}
                  </select>
                </Col>
              )}
            </Row>
          </>
        ) : (
          <Row>
            {/* State */}
            {Stor.find(item => item.hierarchy === "State") && (
              <Col md={Stor.length === 1 && Stor[0].hierarchy === "State" ? 12 : 6}>
                <div className="DropdownHeader">State<span>*</span></div>
                <select
                  className="NCLDropdown w-100"
                  value={inputValues[Stor.find(item => item.hierarchy === "State")?.hierarchyId] || ""}
                  onChange={(e) => {
                    const state = Stor.find(item => item.hierarchy === "State");
                    handleInputChange(state?.hierarchyId, e.target.value);
                    // GetRegionStates(e.target.value, "District");
                  }}
                >
                  <option value="">Select State</option>
                  {stateValues.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.stateDistrictName}
                    </option>
                  ))}
                </select>
              </Col>
            )}

            {/* District */}
            {Stor.find(item => item.hierarchy === "District") && (
              <Col md={6}>
                <div className="DropdownHeader">District<span>*</span></div>
                <select
                  className="NCLDropdown w-100"
                  value={inputValues[Stor.find(item => item.hierarchy === "District")?.hierarchyId] || ""}
                  onChange={(e) => {
                    const district = Stor.find(item => item.hierarchy === "District");
                    handleInputChange(district?.hierarchyId, e.target.value);
                  }}
                  disabled={!districtValues.length}
                >
                  <option value="">Select District</option>
                  {districtValues.map((district) => (
                    <option key={district.id} value={district.id}>
                      {district.stateDistrictName}
                    </option>
                  ))}
                </select>
              </Col>
            )}
          </Row>
        )}
      </div>
      <div className="AddStudent-Buttons dflex mt-3">
        <button className="Buttons" onClick={() => postHierarchyValues()}>
          Save
        </button>
        <button
          className="Buttons CancleButton"
          onClick={() => props.Clear(false)}
        >
          Cancel
        </button>
      </div>
    </div>
  );

};
export default AddEditHierarchyValues;
